import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\Org\Http\Controllers\AuthController::store
* @see app/Domain/Org/Http/Controllers/AuthController.php:27
* @route '//org.launchstation.app/auth/login'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/auth/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::store
* @see app/Domain/Org/Http/Controllers/AuthController.php:27
* @route '//org.launchstation.app/auth/login'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::store
* @see app/Domain/Org/Http/Controllers/AuthController.php:27
* @route '//org.launchstation.app/auth/login'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::store
* @see app/Domain/Org/Http/Controllers/AuthController.php:27
* @route '//org.launchstation.app/auth/login'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::store
* @see app/Domain/Org/Http/Controllers/AuthController.php:27
* @route '//org.launchstation.app/auth/login'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const login = {
    store: Object.assign(store, store),
}

export default login